export const CARD_TYPE = {
  PROPERTY: 'PROPERTY',
  DIRECTORIES: 'DIRECTORIES',
  BROKER: 'BROKER',
  SERVICE: 'SERVICE',
  PROJECT: 'PROJECT',
  PROFESSION: 'PROFESSION',
  STATIC: 'STATIC',
  ABOUTUS: 'ABOUTUS',
};

export const SECTION_TYPE = {
  CAROUSEL: 'carousel-holder',
  LIST_HOLDER: 'list-holder',
};

export const PROPERTY_TYPE = {
  LAND: 'Land',
  UNIT: 'Unit',
  SHOP: 'Shop',
};

export const PROPERTY_STATE = {
  MORTGAGED: 'Mortgaged',
  LEASED: 'Leased',
  VACANT: 'Vacant',
};

export const BROKER_PROJECTIONS = {
  NAME: 'NAME',
  JOBTYPE: 'JOBTYPE',
  OFFICENAME: 'OFFICENAME',
  IMAGE: 'IMAGE',
};

export const BROKER_TYPES = {
  INDIVIDUAL: 'Individual',
  COMPANY: 'Company',
};

export const PROPERTY_PROJECTIONS = {
  TITLE: 'TITLE',
  LOCATION: 'LOCATION',
  AREA: 'AREA',
  OWNERSHIP: 'OWNERSHIP',
  STATUS: 'STATUS',
  STATE: 'STATE',
  PROPERTY_TYPE: 'PROPERTY_TYPE',
  ROAD: 'ROAD',
  BED: 'BED',
  IMAGE: 'IMAGE',
  BATH: 'BATH',
  PROPERTY_IDENTIFIER: 'PROPERTY_IDENTIFIER',
};

export const SERVICES_TYPES = {
  BROKER: 'BRKSRV',
  LEASE: 'LSESRV',
  MORTGAGE: 'MORSRV',
  LONG_LEASE: 'SUYSRV',
  SELL_PURSHASE: 'SEPSRV',
  DOCUMENT_REQUEST: 'DOCSRV',
};

export const COMPONENTS_NAMES = {
  TOP_BANNER_AREA: 'TopBannerArea',
  MARKET_DATA: 'MarketData',
  SERVICE_LIST_BANNER: 'ServiceListBanner',
  SERVICE_LIST_AREA: 'SerivceListArea',
  LATEST_NEWS: 'LatestNews',
  DIRECTORY_SECTION: 'DirectorySection',
  PROPERTY_SECTION: 'PropertySection',
  CONTRACT_SECTION: 'ContractSection',
  REAL_STATE_PROJECTS: 'RealStateProjects',
  Growth_count: 'GrowthCount',
  UpcomingProjects: 'UpComingProjects',
};
